/** @jsxImportSource react */
import React from "react";

import styled from "styled-components";

// Styled-component for SSR CSS generation
const ArrowStyled = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 0;
    opacity: 1;
    flex-shrink: 0;

    &:hover {
        opacity: 0.8;
    }

    &[aria-disabled="true"] {
        opacity: 0.4;
        cursor: not-allowed;
    }

    & svg {
        display: block;
        width: 30px;
        height: 30px;
    }

    & svg rect {
        fill: rgba(244, 245, 247, 1);
    }

    & svg path {
        stroke: rgba(122, 134, 154, 1);
        stroke-width: 2;
        fill: none;
    }
`;

export const Arrow = (props: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <ArrowStyled {...props} />
);
